module.exports = __webpack_public_path__ + "img/icon_iphonewallet_white.8c86fa0.svg";